import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { requestedLanguage } from './preferences/languageStorage.js';
import { configurationI18next } from '@artosera/shared';
import regieFr from './i18n/regie.fr.json' with { type: 'json' };
import regieEn from './i18n/regie.en.json' with { type: 'json' };

/**
 * Français d'abord, anglais ensuite (D15). Les espaces de noms partagés
 * (`commun`, `oeuvres`, `contacts`, `coffre`, `ventes`, `site`, `erreurs`, `presentation`)
 * viennent de `@artosera/shared` ; l'espace de noms `regie` porte les textes
 * propres à cette application (connexion, coquille, tableau de bord, pages en
 * construction) qui n'ont pas leur place dans le paquet partagé.
 */
void i18n.use(initReactI18next).init({
  ...configurationI18next,
  lng: requestedLanguage() ?? 'fr',
  ns: [...configurationI18next.ns, 'regie'],
  resources: {
    fr: { ...configurationI18next.resources.fr, regie: regieFr },
    en: { ...configurationI18next.resources.en, regie: regieEn },
  },
});

function synchronizeDocumentLanguage(language: string): void {
  if (typeof document !== 'undefined')
    document.documentElement.lang = language === 'en' ? 'en' : 'fr';
}
i18n.on('languageChanged', synchronizeDocumentLanguage);
synchronizeDocumentLanguage(i18n.language);

export default i18n;
